<template>
  <modal id="detalhes-registro-notas" class="modal-detalhes-entidade" :titulo="titulo" :loading="loading">
    <template #title-extra>
      <div v-if="ficha && ficha.status !== 'ABERTA' && ficha.status !== 'PENDENTE'" class="badge text-center" :class="classStatus">
        {{statusFormatado}}
      </div>
    </template>

    <template #header>
      <ul class="nav nav-tabs">
        <template  v-for="a in abas">
          <li class="nav-item" :key="a.id" v-if="a.exibir">
            <a @click.prevent="aba = a.id" :title="a.title" class="nav-link py-1 px-2 small"
               href :class="{'active' : aba == a.id}">
              {{a.nome}}
            </a>
          </li>
        </template>
      </ul>
    </template>

    <template #actions>

      <template v-if="mostrarAcoesPosRegistro">
        <li class="list-inline-item" :class="{active : aba == 'anexos'}" >
          <a @click.prevent="aba = 'anexos'" title="Documentação & Anexos" href>
            <i class="fal fa-paperclip"></i>
          </a>
        </li>

        <li class="list-inline-item" :class="{active : aba == 'historico'}">
          <a @click.prevent="aba = 'historico'" title="Histórico" href>
            <i class="fas fa-history"></i>
          </a>
        </li>
      </template>

      <li class="list-inline-item" v-if="mostrarDigitalizacao">
        <router-link :to="{ name: 'digitalizacao', params: { id, entidade: 'INDICADOR', tipoEntidade: livro }}" target="_blank" title="Digitalização">
          <i class="fal fa-file-image"></i>
        </router-link>
      </li>

      <template v-if="mostrarAcoesPosRegistro">
        <li class="list-inline-item">
          <a @click.prevent.stop="imprimir(ficha)" title="Imprimir" href>
            <i class="fal fa-print"></i>
          </a>
        </li>
      </template>

      <li class="list-inline-item" v-if="podeEditar">
        <a @click.prevent.stop="editarIndicador(ficha)" title="Editar Indicador"  href>
          <i class="fal fa-edit"></i>
        </a>
      </li>
    </template>

    <component v-if="!loading && livro" :is="`aba-${this.aba}`" :ficha="ficha" :id="ficha.id" :livro="livro" @load="load"/>
  </modal>
</template>

<script>
  import Modal from "@/components/Modal.vue";
  import AlertBanner from "@/components/alert/AlertBanner.vue";
  import Dados from "@/components/RegistroNotas/Detalhes/Dados.vue";
  import Atos from "@/components/IndicadorGeneric/Detalhes/Atos.vue";
  import Historico from "@/components/IndicadorGeneric/Detalhes/Historico.vue";
  import Anexos from "@/components/IndicadorGeneric/Detalhes/Anexos.vue";
  import Protocolos from "@/components/IndicadorGeneric/Detalhes/Protocolos.vue";
  import EventBus from "@/commons/EventBus";
  import FrontBusiness from "@/business/FrontBusiness";
  import RegistroNotasBusiness from "@/business/indicadores/RegistroNotasBusiness";
  import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness";
  import DominioBusiness from "@/business/protocolo/DominioBusiness";
  import ImprimirFichaV2 from "@/components/Livros/ImprimirFichaV2.vue";
  import FormRegistroNotas from "@/components/RegistroNotas/Form/FormRegistroNotas.vue";

  export default {
    name: 'DetalhesRegistroNotas',

    components: {
      Modal,
      AlertBanner,
      "aba-dados": Dados,
      "aba-atos": Atos,
      "aba-historico": Historico,
      "aba-anexos": Anexos,
      "aba-protocolos": Protocolos,
    },

    props: {
      id: String,
      abaInicial: String
    },

    data() {
      return {
        ficha : {},
        aba : 'dados',
        loading: true,
      }
    },

    modal: {
      width: 900
    },

    async created(){
      await this.load();
      EventBus.$on('ATOS-LOAD', this.load);
    },

    computed: {
      titulo() {
        return FrontBusiness.nomearFicha(this.ficha);
      },

      livro(){
        return this.ficha?.livro;
      },

      abas() {
        return [
          {id: 'dados', nome: 'Dados', exibir: true, title: 'Dados Principais'},
          {id: 'atos', nome: 'Atos Lavrados', exibir: !IndicadorBusiness.isFichaPendente(this.ficha), title: 'Atos Lavrados'},
          {id: 'protocolos', nome: 'Protocolos', exibir: !this.$root.isAuditorOnly}
        ];
      },

      classStatus() {
        return IndicadorBusiness.classStatus(this.ficha.status);
      },

      statusFormatado() {
        return RegistroNotasBusiness.formatarNomeStatus(this.ficha.status);
      },

      usuario() {
        return this.$root.usuarioLogado;
      },

      mostrarAcoesPosRegistro() {
        return !this.$root.isAuditorOnly && !IndicadorBusiness.isFichaPendente(this.ficha);
      },

      podeEditar() {
        return !this.$root.isAuditorOnly && !IndicadorBusiness.isFichaPendente(this.ficha);
      },

      mostrarDigitalizacao() {
        if (DominioBusiness.isDominioLivroUnicoNotas(this.livro)) {
          return !IndicadorBusiness.isFichaPendente(this.ficha);
        }
        return true;
      },
    },

    methods: {
      async load() {
        this.loading = true;

        this.ficha = await RegistroNotasBusiness.getById(this.id);

        if (this.abaInicial) {
          this.$set(this, 'aba', this.abaInicial);
        }

        this.loading = false;
      },

      imprimir(ficha){
        FrontBusiness.openModal(ImprimirFichaV2, {id: ficha.id, tipo: 'REGISTRO_NOTAS', codigo: ficha.codigo});
      },

      async editarIndicador(ficha) {
        if (IndicadorBusiness.isFichaPendente(ficha)) {
          this.$swal('Atenção', 'Não é possível editar uma ficha pendente.', 'warning');
          return;
        }

        const livroPermissao = ficha.livro === 'ABONO_SINAL_PUBLICO' ? 'ESCRITURA' : ficha.livro;
        const permissao = 'PERMITIR_EDITAR_FICHA_' + livroPermissao + '_REGISTRADA';

        if (ficha.abertura && !this.$root.getPermission({id: permissao})) {
          FrontBusiness.showError('', 'Você não tem permissão para editar este indicador.');
          return;
        }

        let result = await FrontBusiness.openModal(FormRegistroNotas, {id: ficha.id, livro: ficha.livro});

        if(result){
          this.$set(this, 'ficha', null);
          await this.load();
        }
      },
    }
  }
</script>
